import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_TITLE: string =
  'Subscription-Based vs. Traditional Music Licensing: Which Is Right for Your Business?'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_TITLE_ES: string =
  'Licencias de música por suscripción o licencias tradicionales: ¿cuál es la mejor solución para su negocio?'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_TITLE_FR: string =
  'Licences musicales par abonnement ou licences traditionnelles : quelle est la meilleure solution pour votre entreprise ?'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_TITLE_KO: string =
  '구독 기반 음악 라이선싱과 기존 음악 라이선싱: 어떤 방식이 귀사에 적합할까요?'

export const SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML: JSX.Element = (
  <>
    Subscription-Based vs. Traditional Music Licensing:
    <br />
    Which Is Right for Your Business?
  </>
)
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_ES: JSX.Element = (
  <>
    Licencias de música por suscripción o licencias tradicionales:
    <br />
    ¿cuál es la mejor solución para su negocio?
  </>
)
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_FR: JSX.Element = (
  <>
    Licences musicales par abonnement ou licences traditionnelles&nbsp;:
    <br />
    quelle est la meilleure solution pour votre entreprise&nbsp;?
  </>
)
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      구독
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      기반
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      음악
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      라이선싱과
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      기존
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      음악
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      라이선싱:
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      어떤
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      방식이
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      귀사에
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      적합할까요?
    </span>
  </>
)

export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE: string =
  '/articles/subscription-based-vs-traditional'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_ES: string =
  '/articles/subscription-based-vs-traditional'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_FR: string =
  '/articles/subscription-based-vs-traditional'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_KO: string =
  '/articles/subscription-based-vs-traditional'

export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_URL: string =
  HOST + SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_ES
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_URL_ES: string =
  HOST + '/es' + SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_ES
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_URL_FR: string =
  HOST + '/fr' + SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_FR
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_URL_KO: string =
  HOST + '/ko' + SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'subscription-based music licensing, traditional music licensing, business background music, commercial music licensing, music licensing for businesses, background music for retail, restaurant background music licensing, music licensing comparison, subscription music service for businesses, affordable business music, public performance music licensing, PRO music licensing, ASCAP BMI SESAC alternatives, royalty-free business music, licensed background music, business music streaming, commercial music streaming service, in-store music licensing, small business music solutions, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'Licencias de música por suscripción, licencias de música tradicionales, música de fondo para negocios, licencias de música comercial, licencias de música para empresas, música de fondo para comercios minoristas, licencias de música de fondo para restaurantes, comparación de licencias de música, servicio de música por suscripción para empresas, música asequible para negocios, licencias de música para ejecución pública, licencias de música PRO, alternativas a ASCAP, BMI y SESAC, música para negocios libre de derechos de autor, música de fondo con licencia, transmisión de música para negocios, servicio de transmisión de música comercial, licencias de música para tiendas, soluciones musicales para pequeñas empresas, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "Licences de musique par abonnement, licences musicales traditionnelles, musique d'ambiance pour entreprises, licences musicales commerciales, licences musicales pour entreprises, musique d'ambiance pour magasins, licences de musique d'ambiance pour restaurants, comparaison des licences musicales, service de musique par abonnement pour entreprises, musique abordable pour entreprises, licences de musique pour diffusion publique, licences musicales PRO, alternatives à ASCAP, BMI et SESAC, musique libre de droits pour entreprises, musique d'ambiance sous licence, streaming musical pour entreprises, service de streaming musical commercial, licences musicales pour commerces, solutions musicales pour petites entreprises, practical stream"
export const ARTICLE_KEYWORDS_KO =
  '구독형 음악 라이선스, 전통적인 음악 라이선스, 사업장 배경 음악, 상업용 음악 라이선스, 비즈니스 음악 라이선스, 매장 배경 음악, 레스토랑 배경 음악 라이선스, 음악 라이선스 비교, 기업용 구독형 음악 서비스, 기업을 위한 합리적인 가격의 음악, 공개 공연용 음악 라이선스, 저작권 관리 단체(PRO) 음악 라이선스, ASCAP, BMI, SESAC 대체 서비스, 기업을 위한 로열티 프리 음악, 라이선스 취득 배경 음악, 기업용 음악 스트리밍, 상업용 음악 스트리밍 서비스, 소매업체를 위한 음악 라이선스, 소규모 사업체를 위한 음악 솔루션, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'D3C44395-EA4D-47A0-9399-AFABD180206B.avif'
  : HOST + '/images/D3C44395-EA4D-47A0-9399-AFABD180206B.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'D3C44395-EA4D-47A0-9399-AFABD180206B.jpg'
  : HOST + '/images/D3C44395-EA4D-47A0-9399-AFABD180206B.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '94F947CD-28EA-4167-862A-155572DA5299.jpg'
  : HOST + '/images/94F947CD-28EA-4167-862A-155572DA5299.jpg'

export const SUBSCRIPTION_BASED_VS_TRADITIONAL_JSON_LD_IMAGE_1200_X_1200: string =
  USE_CDN
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'B82B2D3C-D4EE-4639-8158-C72EBDE34B6C.png'
    : HOST + '/images/B82B2D3C-D4EE-4639-8158-C72EBDE34B6C.png'

export const ARTICLE_SUMMARY: string =
  'Understanding the difference between subscription-based and traditional music licensing will help you choose the right solution, stay compliant, and avoid costly litigation for violating copyrights.'
export const ARTICLE_SUMMARY_ES: string =
  'Comprender las diferencias entre las licencias de música por suscripción y las licencias de música tradicionales le ayudará a elegir la solución adecuada, cumplir con la normativa y evitar costosos juicios por infracción de derechos de autor.'
export const ARTICLE_SUMMARY_FR: string =
  "Comprendre les différences entre les licences musicales par abonnement et les licences musicales traditionnelles vous aidera à choisir la solution adaptée, à respecter la réglementation et à éviter des poursuites coûteuses pour violation des droits d'auteur."
export const ARTICLE_SUMMARY_KO: string =
  '구독 기반 음악 라이선스와 기존 음악 라이선스의 차이점을 이해하면 올바른 솔루션을 선택하고, 법규를 준수하며, 저작권 침해로 인한 값비싼 소송을 피할 수 있습니다.'

export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_PUBLISHED_STR: string =
  '2026-01-01'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_CREATED_STR: string =
  '2026-01-01'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_PUBLISHED: Date =
  new Date(SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_PUBLISHED_STR)
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_CREATED: Date = new Date(
  SUBSCRIPTION_BASED_VS_TRADITIONAL_ARTICLE_CREATED_STR
)
